module.exports = __webpack_public_path__ + "static/img/yuqi-state1.68866c2a.png";